import { useState } from 'react';

export const useDragReorder = () => {
  const [draggingIndex, setDraggingIndex] = useState<number | null>(null);
  const [dragOverIndex, setDragOverIndex] = useState<number | null>(null);
  const [dragOverPosition, setDragOverPosition] = useState<'top' | 'bottom' | null>(null);

  const handleDragStart = (index: number) => {
    setDraggingIndex(index);
  };

  const handleDragOver = (e: React.DragEvent, index: number) => {
    e.preventDefault();
    const target = e.currentTarget.getBoundingClientRect();
    const offsetY = e.clientY - target.top;
    const position = offsetY < target.height / 2 ? 'top' : 'bottom';
    setDragOverIndex(index);
    setDragOverPosition(position);
  };

  const handleDragLeave = () => {
    setDragOverIndex(null);
    setDragOverPosition(null);
  };

  const handleDrop = (e: React.DragEvent, index: number, onReorder: (fromIndex: number, toIndex: number) => void) => {
    e.preventDefault();
    if (draggingIndex !== null) {
      const insertIndex = dragOverPosition === 'bottom' ? index + 1 : index;
      onReorder(draggingIndex, insertIndex);
    }
    resetDragState();
  };

  const resetDragState = () => {
    setDraggingIndex(null);
    setDragOverIndex(null);
    setDragOverPosition(null);
  };

  return {
    draggingIndex,
    dragOverIndex,
    dragOverPosition,
    handleDragStart,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    resetDragState,
  };
};